import React, { useEffect, useState } from "react";
import { Table, Typography, Tooltip, Button, Row, Col,Card,Affix, message } from 'antd';
import GenericAddRemoveMultipleRecords from "../SetupComponent/GenericAddRemoveMultipleRecordsUI";
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';


const { Title } = Typography;

const AccessPolicyGroupDetailPage=({fetchAccessPolicyGroups,selectedAccessPolicyGroup,onBack,allUsers,allAccessPolcies})=>{ 

    const [selectedUsers,setSelectedUsers]=useState([]);
    const [selectedAccessPolcies,setSelectedAccessPolcies]=useState([]);

    useEffect(()=>{
        setSelectedUsers(selectedAccessPolicyGroup.assigned_to_ids);
        setSelectedAccessPolcies(selectedAccessPolicyGroup.MtAccessPolicy_ids);
    },[selectedAccessPolicyGroup])

    const handleSave=async()=>{

        try{

            selectedAccessPolicyGroup.assigned_to_ids=selectedUsers;
            selectedAccessPolicyGroup.MtAccessPolicy_ids=selectedAccessPolcies;

         

            const apiService = new ApiService(
                `${BASE_URL}/update_access_policy_group/${selectedAccessPolicyGroup?._id}`,
                { 'Content-Type': 'application/json' },
                'PATCH', selectedAccessPolicyGroup
            );

            const response=await apiService.makeCall();
            message.success('Policy Group Saved Successfully');
            fetchAccessPolicyGroups();
            onBack();


        }
        catch(error){
            message.error('Error saving policy group');
            onBack();
        }

    }

    const cancelEditing=()=>{

        onBack();
    }

    return(

        <div style={{height:'80vh',overflowY:'scroll'}}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <Row justify="space-between" align="middle" style={{ marginBottom: '16px' }}>
                    <Col>
                        <Title level={3} style={{ margin: 0 }}>
                            {selectedAccessPolicyGroup?.Name}
                        </Title>
                    </Col>
                    <Col>
                        <Button type="primary" onClick={onBack} style={{marginRight:'3px'}}>
                            Back
                        </Button>
                    </Col>
                </Row>
            </div>

            <Card>
             <h3>Configure Assigned Users</h3>   
            <GenericAddRemoveMultipleRecords
                    titleLeft="Available Users"
                    titleRight="Selected Users"
                    dataSource={allUsers}
                    selectedKeys={selectedUsers}
                    onUpdateSelectedKeys={setSelectedUsers}
                    columnsLeft={[{ title: 'Name', dataIndex: 'Name', key: 'Name' }]}
                    columnsRight={[{ title: 'Name', dataIndex: 'Name', key: 'Name' }]}
                    searchFields={['Name', 'username']}
                />
            </Card>

            <Card>
             <h3>Configure Assigned Access Policies</h3>   
            <GenericAddRemoveMultipleRecords
                    titleLeft="Available Access Polcies"
                    titleRight="Selected Access Polcies"
                    dataSource={allAccessPolcies}
                    selectedKeys={selectedAccessPolcies}
                    onUpdateSelectedKeys={setSelectedAccessPolcies}
                    columnsLeft={[{ title: 'Name', dataIndex: 'Name', key: 'Name' }]}
                    columnsRight={[{ title: 'Name', dataIndex: 'Name', key: 'Name' }]}
                    searchFields={['Name']}
                />
            </Card>

            <Affix offsetBottom={0}>
          <div
            style={{
              position: "sticky",
              bottom: 0,
              background: "rgba(240, 242, 245, 0.9)",
              padding: "10px 0",
              boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
              textAlign: "center",
            }}
          >
            <Button type="primary" onClick={handleSave} style={{ marginRight: 10 }}>
              Save
            </Button>
            <Button type="default" onClick={cancelEditing}>
              Cancel
            </Button>
          </div>
        </Affix>
        </div>

    );


}

export default AccessPolicyGroupDetailPage;